import React, { useState } from "react";
import AuthLayout from "../AuthLayout";
import InputField from "../../shared/InputField";
import { singIn } from "../../../api/authApis";
import GoogleAuth from "../../shared/GoogleAuth";
import Button from "../../shared/Button";
import hidePassword from "~/images/hide-password.svg";
import showPasswordIcon from "~/images/password-visible.svg";
const App = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    const errs = {};
    if (!form.email) {
      errs.email = "Eamil is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errs.email = "Invalid email format";
    }
    if (!form.password) {
      errs.password = "Password is required";
    }
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (typeof amplitude !== "undefined") {
        amplitude.track("onboarding_logIn_click", {});
      }
    } catch (err) {
      console.warn("Amplitude tracking failed:", err);
    }

    const validationsErrors = validate();
    if (Object.keys(validationsErrors).length === 0) {
      const response = await singIn(form);
      if (response.data.success) {
        window.location.reload();
      }
    } else {
      setErrors(validationsErrors);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <AuthLayout>
      <div>
        <div className="w-[370px] max-[400px]:w-[330px] sm:w-[500px] max-w-full min-h-[420px] bg-white rounded-lg border border-[#ebebeb] py-[45px] px-6 sm:px-[55px] mt-[120px] mx-auto max-sm:mb-[100px]">
          {/* <h1 className="text-2xl text-center font-semibold mt-5 mb-8">Sign in to your account</h1> */}
          <GoogleAuth text="Sign in with Google" type="sign-in" />
          <form onSubmit={handleSubmit} noValidate className="mb-6">
            <div className="mb-4">
              <InputField
                label="Email"
                labelClasses="!arial-font font-normal !text-[#636363]"
                name="email"
                type="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
                error={errors.email}
                extraClasses="!bg-[#fbf7f55e] !border-gray-200 !rounded-md"
              />
            </div>
            <div className="mb-6">
              <div className="flex items-center justify-between">
                <label className="block text-sm mb-2  !arial-font !font-normal !text-[#636363]">Password</label>
                <a className="text-sm text-[#550df4]" href="/users/password/new">
                  Forgot Password?
                </a>
              </div>
              <InputField
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                error={errors.password}
                extraClasses="!bg-[#fbf7f55e] !border-gray-200 !rounded-md"
                icon={
                  showPassword ? (
                    <img src={showPasswordIcon} onClick={togglePasswordVisibility} className="h-[18px] w-[18px] cursor-pointer" />
                  ) : (
                    <img src={hidePassword} onClick={togglePasswordVisibility} className="h-[18px] w-[18px] cursor-pointer" />
                  )
                }
              />
            </div>
            <Button type="submit" className="w-full !min-h-[55px] !font-medium  !py-3 !px-4 !text-base !rounded-md">
              Sign In
            </Button>
          </form>
          <div class="flex items-center justify-center gap-2 text-center mb-5">
            <p className=" text-[#000]">Not a member? </p>
            <a href="/sign-up" className="underline text-[#550df4]">
              Register
            </a>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};
export default App;
